import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { ModalConfirmacaoComponent } from 'src/app/@shared/components';
import { ConferenciaVolume } from 'src/app/@shared/models/confVolume';
import { ConferenciaVolumeService } from 'src/app/services/confVolume/conferencia-volume.service';
import { FilialService } from 'src/app/services/filial/filial.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { AcompRemessaComponent } from './acomp-remessa/acomp-remessa.component';
import { DetalhesLoteComponent } from './detalhes-lote/detalhes-lote.component';
import { ModalTransformarProdutoEmRiscoComponent } from './modal-transformar-produto-em-risco/modal-transformar-produto-em-risco.component';
import { ProdutoService } from 'src/app/services/produto/produto.service';
@Component({
  selector: 'app-conferencia-volume',
  templateUrl: './conferencia-volume.component.html',
  styleUrls: ['./conferencia-volume.component.scss']
})
export class ConferenciaVolumeComponent implements OnInit {

  isLoading = false;
  excelUrl;
  acessoDetalhes: boolean;
  acessoAcompanhamento: boolean;
  acessoProdutoRisco: boolean;
  isLoadingDownload: boolean;
  private onDestroy = new Subject<void>();

  filialIdSelecionado: any;
  public filteredFiliais: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filialMultiFilter: FormControl = new FormControl();
  filiais: any[];
  filial;

  filterForm = new FormGroup({
    dataInicio: new FormControl(Validators.required),
    dataFim: new FormControl(Validators.required),
    codigoPacking: new FormControl(),
    filialSelecionado: new FormControl(),
    clienteFormControl: new FormControl(),
    produto: new FormControl({value: '', disabled: true}),
  });
  get dataInicio() { return new Date(this.filterForm.get('dataInicio').value.toString()); }
  get dataFim() { return new Date(this.filterForm.get('dataFim').value.toString()); }
  get codigoPacking() { return this.filterForm.get('codigoPacking').value; }
  get filialSelecionado() { return this.filterForm.get('filialSelecionado').value; }
  get clienteFormControl() { return this.filterForm.get('clienteFormControl').value; }
  get produto() { return this.filterForm.get('produto').value; }

  public displayedColumns: string[] = ['action', 'codigo', 'codigoPackingList', 'cliente', 'produto', 'filialOrigem', 'numLote', 'qtde', 'dtEntrada'];
  public gridVolumes: MatTableDataSource<ConferenciaVolume> = new MatTableDataSource<ConferenciaVolume>();
  public paging = { index: 0, size: 10, length: 0 };

  clienteId: number;
  produtos: any[] = [];

  constructor(
    public snackBar: MatSnackBar,
    public filialService: FilialService,
    public confVolumeService: ConferenciaVolumeService,
    public dialog: MatDialog,
    public authService: AuthService,
    public produtoService: ProdutoService
  ) { }

  ngOnInit() {
    this.iniciarDatas();
    this.mostrarFiliais();

    this.authService.checkFeature('outros.risco.conferencia-volumes.detalhes-lote').subscribe((temPermissao: any) => {
      if (temPermissao === true) this.acessoDetalhes = temPermissao;
      else this.acessoDetalhes = false;
    });
    this.authService.checkFeature('outros.risco.conferencia-volumes.acompanhamento-volumes').subscribe((temPermissao: any) => {
      if (temPermissao === true) this.acessoAcompanhamento = temPermissao;
      else this.acessoAcompanhamento = false;
    });
    this.authService.checkFeature('outros.risco.conferencia-volumes.transformar-produto-risco').subscribe((temPermissao: any) => {
      if (temPermissao === true) this.acessoProdutoRisco = temPermissao;
      else this.acessoProdutoRisco = false;
    });

    this.filterForm.get('clienteFormControl').valueChanges.subscribe(
      (value: string) => {
        if (!value || value.length === 0) {
          this.clienteId = null;
          this.produtos = null;
          this.filterForm.controls.produto.disable();
          this.filterForm.get('produto').setValue(null);
          this.filterForm.get('produto').updateValueAndValidity();
        }
      }
    )
  }

  reciverFeedback(respostaFilho) {
    this.clienteId = respostaFilho;
    respostaFilho && this.selecionarProdutos();
  }

  selecionarProdutos() {
    this.produtoService.selecionarProdutos(this.clienteId).subscribe(response => {
      this.produtos = response;
      this.verificaProduto();
    },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar('Ocorreu um erro ao consultar! Tente novamente ou entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  verificaProduto() {
    if (this.clienteId) {
      this.filterForm.controls.produto.enable();
    } else {
      this.filterForm.controls.produto.disable();
      this.produtos = [];
      this.filterForm.get('produto').setValue(null);
      this.filterForm.get('produto').updateValueAndValidity();
    }
  }

  validaData() {
    const de = new Date(this.dataInicio.toString());
    const ate = new Date(this.dataFim.toString());
    const diffTime = Math.abs(ate.getTime() - de.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  }

  getGridVolumes() {

    if ((this.dataInicio && this.dataFim && (this.dataFim < this.dataInicio))) {
      return this.openSnackBar('A data término não pode ser maior que a data início!', 'OK', 5000, 'warning-snackbar');
    }

    if (this.validaData() > 7) {
      return this.openSnackBar('Por favor informe um período de busca para no máximo 7 dias!', 'OK', 5000, 'warning-snackbar');
    }

    this.isLoading = true;
    this.gridVolumes.data = null;
    const obj = {
      dtIni: this.dataInicio ? this.dataInicio.toISOString().split('T')[0] : null,
      dtFim: this.dataFim ? this.dataFim.toISOString().split('T')[0] : null,
      numMovimento: this.codigoPacking,
      filialId: this.filialIdSelecionado === undefined ? null : this.filialIdSelecionado,
      clienteID: this.clienteId,
      produtoIDs: this.produto ? [Number(this.produto)] : null,
      paginaAtual: this.paging.index + 1,
      itensPorPagina: this.paging.size,
    };
    this.confVolumeService.confVolumeTotal(obj)
      .subscribe((response: ConferenciaVolume[]) => {
        if (response) {
          this.gridVolumes.data = response;
          response.length ? this.paging.length = response[0].totalCount : null;
        }
        else {
          this.openSnackBar('Erro ao carregar listagem!', 'OK', 5000, 'danger-snackbar');
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.gridVolumes.data = null;
        this.openSnackBar('Erro ao carregar listagem, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      })
      .add(() => this.isLoading = false);
  }

  public mostrarFiliais() {
    this.filialService.listarFilialDestino().subscribe((response: any) => {
      this.filiais = response.filter(x => x.descricao != '').sort((a, b) => (a.descricao < b.descricao ? -1 : 1));
      this.filteredFiliais.next(this.filiais.slice());
      this.filialMultiFilter.valueChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(() => {
          this.filterFilial();
        });
    },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.isLoading = false;
        this.openSnackBar('Erro ao carregar filiais, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  };

  private filterFilial() {
    if (!this.filiais) {
      return;
    }
    let search = this.filialMultiFilter.value;
    if (!search) {
      this.filteredFiliais.next(this.filiais.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredFiliais.next(
      this.filiais.filter(filial => filial.descricao.toLowerCase().indexOf(search) > -1)
    );
  }

  onPageChange(evt: { pageIndex: number, pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.getGridVolumes();
  }

  iniciarDatas() {
    const filtroFim = new Date();
    const filtroInicio = new Date(filtroFim);
    filtroInicio.setDate(filtroInicio.getDate() - 7);
    this.filterForm.get('dataInicio').setValue(filtroInicio as any);
    this.filterForm.get('dataFim').setValue(filtroFim as any);
  }

  clearFields() {
    this.filterForm.controls.produto.disable();
    this.filterForm.reset();
    this.produtos = [];
    this.clienteId = null;
    this.iniciarDatas();
    this.gridVolumes.data = null;
  }

  modalDetalhesLote(loteId: number) {
    const dialogRef = this.dialog.open(DetalhesLoteComponent, {
      width: '1200px',
      data: { loteId }
    });
    dialogRef.afterClosed()
  }

  modalAcompanharRemessa(gridVolumes) {
    const dialogRef = this.dialog.open(AcompRemessaComponent, {
      width: '750px',
      maxHeight: '650px',
      data: gridVolumes ? gridVolumes : null
    });
    dialogRef.afterClosed()
  }

  async modalConfirmacao(texto: string, operacao, gridVolumes) {
    const dialogRef = this.dialog.open(ModalConfirmacaoComponent, {
      width: '450px',
      data: {
        textoCancelar: "Não",
        textoOk: "Sim",
        texto,
      },
    })
    dialogRef.afterClosed().subscribe(
      async modalResponse => {
        if (modalResponse === 1) {
          if (operacao === 'transformarRisco') {
            this.modalTransformarProdutoEmRisco(gridVolumes.numLote)
          } else if (operacao === 'transformarOriginal') {
            this.confVolumeService
              .rollbackTransformarProdutoEmRisco(gridVolumes.numLote).subscribe(
                (response) => {
                  if (response.success) {
                    this.getGridVolumes();
                    return this.openSnackBar(
                      `Operação realizada com sucesso!`,
                      'OK',
                      5000,
                      'success-snackbar'
                    );
                  } else {
                    return this.openSnackBar(
                      response.mensagem,
                      'OK',
                      5000,
                      'danger-snackbar'
                    );
                  }
                },
                (err: HttpErrorResponse) => {
                  console.error(err);
                })
          }
        }
      });
  }

  modalTransformarProdutoEmRisco(loteID) {
    const dialogRef = this.dialog.open(ModalTransformarProdutoEmRiscoComponent, {
      width: '750px',
      data: { loteID },
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response === 'success') {
        this.getGridVolumes();
        return this.openSnackBar(
          `Operação realizada com sucesso!`,
          'OK',
          5000,
          'success-snackbar'
        );
      }
    });
  }

  // Chamada do Excel;
  base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  gerarArquivo(data: any, filename: string, type: string) {
    const arrBuffer = this.base64ToArrayBuffer(data)
    const blob = new Blob([arrBuffer], {
      type
    });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downloadExcel() {
    this.isLoadingDownload = true;
    const obj: any = {
      dtIni: this.dataInicio ? this.dataInicio.toISOString().split('T')[0] : null,
      dtFim: this.dataFim ? this.dataFim.toISOString().split('T')[0] : null,
      numMovimento: this.codigoPacking,
      filialId: this.filialIdSelecionado === undefined ? null : this.filialIdSelecionado,
      clienteID: this.clienteId,
      produtoIDs: this.produto,
      paginaAtual: this.paging.index + 1,
      itensPorPagina: this.paging.size,
    };
    this.confVolumeService.exportarExcel(obj).subscribe(
      (response: any) => {
        this.gerarArquivo(
          response.retorno.fileContents,
          response.retorno.fileDownloadName,
          response.retorno.contentType
        )
      },
      (err: HttpErrorResponse) => console.error('erro', err),
      () => this.isLoadingDownload = false
    )
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
